import Crud from '../views/LinhaCuidado/Crud'
import Entity from '../views/LinhaCuidado/Add'
import View from '../views/LinhaCuidado/View'

let routes = {
    path: '/linha_cuidados',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/linha_cuidados/add',
            name: 'NewLinhaCuidado',
            component: Entity,
            meta: {
                pageTitle: 'Criação de Linha de Cuidados',
                breadcrumb: [
                    {
                        text: 'Linha de Cuidados',
                        active: false,
                        to: '/linha_cuidados',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/linha_cuidados/edit/:id?',
            name: 'EditLinhaCuidado',
            component: Entity,
            meta: {
                pageTitle: 'Edição de LinhaCuidado',
                breadcrumb: [
                    {
                        text: 'Linha de Cuidados',
                        active: false,
                        to: '/linha_cuidados',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/linha_cuidados/view/:id?',
            name: 'ViewLinhaCuidado',
            component: View,
            meta: {
                pageTitle: 'Visualizar LinhaCuidado',
                breadcrumb: [
                    {
                        text: 'Linha de Cuidados',
                        active: false,
                        to: '/linha_cuidados',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/linha_cuidados',
            name: 'list-linha_cuidados',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Linha de Cuidados',
                breadcrumb: [
                    {
                        text: 'Linha de Cuidados',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
